import { render, staticRenderFns } from "./usersPinned.vue?vue&type=template&id=622fde95&"
import script from "./usersPinned.vue?vue&type=script&lang=js&"
export * from "./usersPinned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports